import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteArticle } from './actions';
import { getArticles } from './reducer';
import { hasMutation } from './utils';

class ArticleList extends Component {
  deleteArticle = id => {
    this.props.deleteArticle(id, 'cs');
  };

  renderTable = () => {
    const { articles } = this.props;

    return articles.map((item, index) => {
      const hasCs = hasMutation(item, 'cs');
      const hasEn = hasMutation(item, 'en');
      return (
        <tr key={index}>
          <td>{hasCs ? item.header.cs : hasEn ? item.header.en : ''}</td>
          <td>
            <Link
              to={{
                pathname: hasCs ? `/clanky/edit/${item.id}/cs` : `/clanky/new`,
                state: { id: item.id, lang: 'cs', disableSelect: true }
              }}
            >
              {hasCs ? 'Upravit cs' : 'Vytvořit cs'}
            </Link>
          </td>
          <td>
            <Link
              to={{
                pathname: hasEn ? `/clanky/edit/${item.id}/en` : `/clanky/new`,
                state: { id: item.id, lang: 'en', disableSelect: true }
              }}
            >
              {hasEn ? 'Upravit en' : 'Vytvořit en'}
            </Link>
          </td>
          <td>{item.updated}</td>
        </tr>
      );
    });
  };

  render() {
    const { articles } = this.props;

    if (articles.length === 0) {
      return <div>Seznam článků je prázdný</div>;
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>Název</th>
            <th>Cs</th>
            <th>En</th>
            <th>Naposledy upraveno</th>
          </tr>
        </thead>
        <tbody>{this.renderTable()}</tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    articles: getArticles(state)
  };
};

export default connect(
  mapStateToProps,
  { deleteArticle }
)(ArticleList);



// WEBPACK FOOTER //
// ./src/modules/ArticleList/index.js